<template>
    <div class="mapbox-cookie-info">
        <el-dialog 
            :visible.sync="dialogVisible"
            :append-to-body="true"
            :close-on-click-modal="false"
            :center="true"
            :top="'0'"
            :show-close="false" 
            custom-class="mapbox-cookie-info__dialog"
        >
            <div class="mapbox-cookie-info__dialog__body">
                <div class="copy-bold black mapbox-cookie-info__dialog__title">Datenschutz</div>
                <div class="copy">Zur Anzeige der Karte von <a href="https://www.mapbox.com/" target="_blank">Mapbox</a> (<a href="https://www.mapbox.com/legal/privacy" target="_blank">Mapbox Datenschutzbestimmungen</a>) benötigen wir Ihre Einwilligung.</div>
                <SmrButton class="black mapbox-cookie-info__dialog__button" @click.native="acceptClickHandler">Einwilligen</SmrButton>
                <div class="mapbox-cookie-info__dialog__bottom">
                    <div class="copy-light-small">Detaillierte Informationen über den Einsatz von Cookies auf dieser Webseite erhalten Sie in unserer <a href="https://www.oeamtc.at/datenschutz" target="_blank">Datenschutzerklärung</a> und den <a href="" @click="cookieSettingsClickHandler">Cookie-Einstellungen</a>.</div>
                </div>
            </div>
        </el-dialog>
    </div>
</template>
<script>
    import { showMapboxServiceInfo, acceptMapboxService, mapboxServiceAccepted } from '@/utils/user-centrics'
    import SmrButton from '@/components/SmrButton.vue'
    import eventBus from '@/utils/event-bus'

    export default {
        components: {
            SmrButton,
        },
        data() {
            return {
                dialogVisible: false,
                recheckServicesInterval: false,
            }
        },
        mounted() {
            this.addListeners();
        },
        beforeDestroy() {
            this.removeListeners()
        },
        methods: {
            hideDialog() {
                this.dialogVisible = false;
            },
            showDialog() {
                this.dialogVisible = true;
                this.initServiceCheckInterval()
            },
            cookieSettingsClickHandler(e) {
                e.preventDefault()
                showMapboxServiceInfo()
            },
            acceptClickHandler() {
                acceptMapboxService(() => {
                    eventBus.$emit('initMap')
                    this.hideDialog()
                })
            },
            initServiceCheckInterval() {
                this.recheckServicesInterval = setInterval(() => {
                    if(mapboxServiceAccepted()) {
                        clearInterval(this.recheckServicesInterval)
                        eventBus.$emit('initMap')
                        this.hideDialog()
                    }
                }, 500);
            },
            addListeners() {
                eventBus.$on('showMapboxServiceInfo', this.showDialog);
            },
            removeListeners() {
                eventBus.$off('showMapboxServiceInfo', this.showDialog);
            },
        }
    }
</script>
<style lang="scss">
.mapbox-cookie-info {
    $block: &;

    &__dialog {
        width: calc(100% - 32px);
        top: 50%;
        transform: translateY(-50%);
        border-radius: $standard-border-radius;

        @include mq(tablet) {
            max-width: 500px;
        }

         .el-dialog {
            &__wrapper {
                background: transparent;
            }

            &__header {
                display: none;
            }

            &__body {
                padding: 0;
                word-break: initial;
                font-size: 15px;
            }
        }

        &__body {
            padding: 24px;
            
            @include mq(tablet) {
                padding: 30px;
            }
        }

        &__title {
            margin-bottom: 12px;
        }

        &__button {
            margin-top: 24px;
            margin-bottom: 24px;

        }

        &__bottom {
            border-top: 1px solid $color-grey-outline;
            padding-top: 12px;
        }
    }
}

</style>
